import {Component, OnInit, EventEmitter, Output, Injector} from "@angular/core";
import {
    ScannerPrimarySearchList,
    ScannerSide,
    ScannerSideListItems,
    ScannerChartingStudy,
    ScannerChartingStudyItems,
    ScannerPrimarySearchListItems
} from "../interfaces/scanner.enums";
import {AppComponentBase} from "../../../services/AppComponentBase";
import {HistoryItemPeriod, historyPeriods} from "../../../interfaces/historyItem";

@Component({
    selector: "app-scanner-NarrowScanner",
    template: require('./scanner-NarrowScanner.component.html'),
    styles: [
        require('./scanner-NarrowScanner.component.scss'),
        require('../scanner-Results/scanner-Results.component.scss'),
        require('./../scannerTab/scannerTab.component.scss')
    ]
})
export class ScannerNarrowScannerComponent extends AppComponentBase implements OnInit {
    sideList: object = ScannerSideListItems();

    @Output("back")
    change: EventEmitter<boolean> = new EventEmitter<boolean>();

    back() {
        this.workspace.isNarrowScanMode = false;
        this.change.emit(true);
    }

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnInit() {}
    narrowSearchInstruments: object = ScannerPrimarySearchListItems();
    public ScannerPrimarySearchList = ScannerPrimarySearchList;
    public ScannerChartingStudy = ScannerChartingStudy;
    chartingStudyList: object = ScannerChartingStudyItems();


    public get narrowScanComponent(): ScannerPrimarySearchList | undefined {
        return this.workspace.narrowScanComponent;
    }
    public set narrowScanComponent(value: ScannerPrimarySearchList | undefined) {
        this.workspace.narrowScanComponent = value || ScannerPrimarySearchList.SCANNER_NA;
    }

    private _scannerHead: string = "Narrow search";
    public get scannerHead(): string {
        return this._scannerHead;
    }
    public set scannerHead(value: string) {
        this._scannerHead = value;
    }

    public activeNarrowComponent(val: ScannerPrimarySearchList) {


        if(this.workspace.checkAvaiabilityofComponent(val)) {
            this.narrowScanComponent = this.narrowScanComponent != val ? val : undefined;
        }
        else {
            this.globaGridMode.scannerReminderLauncher.next(true);
        }

    }

    public get scannerSearch_Narrow_side(): ScannerSide | string {
        return this.workspace.scannerSearch_Narrow_side;
    }
    public set scannerSearch_Narrow_side(value: ScannerSide | string) {
        this.workspace.globaGridMode.changeScannerNarrowSide.next(value);

        this.workspace.scannerSearch_Narrow_side = value;
    }

    public get scannerSearch_Narrow_chartingstudy(): ScannerChartingStudy | string {
        return this.workspace.scannerSearch_Narrow_chartingstudy;
    }
    public set scannerSearch_Narrow_chartingstudy(value: ScannerChartingStudy | string) {
        this.workspace.scannerSearch_Narrow_chartingstudy = value;
    }





    public get periods(): {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[] {
        return this.workspace.periodsList;
    }

    public set periods(value: {
        id: number;
        label: string;
        css: string;
        Order: number;
        Standard?: boolean;
        Oanda?: boolean;
    }[]) {
        this.workspace.periodsList = value;
    }

    public get scannerSearch_Narrow_period(): HistoryItemPeriod | string {
        return this.workspace.scannerSearch_Narrow_period;
    }
    public set scannerSearch_Narrow_period(value: HistoryItemPeriod | string) {
        this.workspace.scannerSearch_Narrow_period = value;
        //this.workspace.globaGridMode.changeScannerSide.next(value);
    }

    private _isNarrowScanProcess: boolean = false;
    public get isNarrowScanProcess(): boolean {
        return this._isNarrowScanProcess;
    }
    public set isNarrowScanProcess(value: boolean) {
        this._isNarrowScanProcess = value;
    }
    public scanNarrowProcess() {
        this.workspace.globaGridMode.runNarrowScanProcess.next(this.narrowScanComponent);
        this.isNarrowScanProcess = true;
    }

    private _narrowScanFinished: boolean = false;
    public get narrowScanFinished(): boolean {
        //return this._narrowScanFinished;
        return this.workspace.narrowscanFinished;
    }
    public set narrowScanFinished(value: boolean) {
        this._narrowScanFinished = value;
    }

    public get showSide(): boolean {
        if(this.narrowScanComponent == undefined) {
            this.workspace.usePrimarySide = true;
            return false;
        } else {
            if(
                this.workspace.selectedPrimaryScanner != "scanner_tiwizard" &&
                this.workspace.selectedPrimaryScanner != "scanner_entrysignals"
            ) {
                this.workspace.usePrimarySide = true;
                return false;
            } else {
                if(
                    this.narrowScanComponent != ScannerPrimarySearchList.SCANNER_WIZARD &&
                    this.narrowScanComponent != ScannerPrimarySearchList.SCANNER_CHARTING
                ) {
                    this.workspace.usePrimarySide = true;
                    return false;
                }
                this.workspace.usePrimarySide = false;
                return true;
            }
        }

        this.workspace.usePrimarySide = false;
        return true;
    }


    public setActiveInstrument(id: any) {
        this.activeNarrowComponent(id);
    }

    public get selectedScannerImage() {
        let img = (this.narrowSearchInstruments as {id: string, label: string, image?: string}[]).find(v => {
            return v.id == this.narrowScanComponent
        })

        if(img) {
            return img.image
        }
        else {
            return "";
        }
    }


    public get canNarrowScan() {
        if(!this.workspace.isNarrowScanMode) {
            return true;
        }


        if(this.workspace.scannerCurrentRule_Narrow == undefined) {
            return false;
        }

        if(this.narrowScanComponent != 'scanner_entrysignals') {
            if(this.workspace.scannerSearch_Narrow_period == "NO") {
                return false
            }

        }

        if(this.narrowScanComponent == 'scanner_tiwizard') {
            if(this.workspace.scannerCurrentRule_Narrow.momentum == undefined
                && this.workspace.scannerCurrentRule_Narrow.volatility == undefined
                && this.workspace.scannerCurrentRule_Narrow.buyingselling == undefined) {
                return false
            }

        }

        if(this.narrowScanComponent == 'scanner_entrysignals') {
            if(this.workspace.scannerCurrentRule_Narrow.LData == undefined ||
                this.workspace.scannerCurrentRule_Narrow.MData == undefined ||
                this.workspace.scannerCurrentRule_Narrow.SData == undefined ||
                this.workspace.scannerCurrentRule_Narrow.EData == undefined
            ) {
                return false;
            }


            if(this.workspace.scannerCurrentRule_Narrow.LData.direction == undefined
                && this.workspace.scannerCurrentRule_Narrow.MData.direction == undefined
                && this.workspace.scannerCurrentRule_Narrow.SData.direction == undefined
                && this.workspace.scannerCurrentRule_Narrow.EData.direction == undefined) {
                return false
            }

        }

        if(this.narrowScanComponent == 'scanner_charting') {
            if(this.workspace.scannerSearch_Narrow_chartingstudy == "") {
                return false
            }
        }

        return true;
    }


    public backFromNArrow() {
        this.workspace.globaGridMode.fullScreenScanerAction.next("backFromNarrow");
    }

    private _canSave: boolean = true;
    public get canSave(): boolean {

        if(this.workspace.selectedSavedScan == "" && this.canNarrowScan) {
            return true
        }

        if(this.workspace.selectedSavedScan != "" && this.canNarrowScan && this.workspace.canSelectedSavedScanUpdate) {
            return true;
        }

        return false;

    }
    public set canSave(value: boolean) {
        this._canSave = value;
    }

    public saveScan() {
        if(this.canSave) {
            this.workspace.globaGridMode.fullScreenScanerAction.next("saveScan");
        }

    }


}
